/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export type CryptoAddress = {
    /**
     * Cryptocurrency type: 10=BTC, 20=ETH, 30=USDT
     */
    coinType?: CryptoAddress.coinType;
    /**
     * Crypto wallet address
     */
    address?: string;
    /**
     * User ID who owns this address
     */
    userId?: string;
};
export namespace CryptoAddress {
    /**
     * Cryptocurrency type: 10=BTC, 20=ETH, 30=USDT
     */
    export enum coinType {
        '_10' = 10,
        '_20' = 20,
        '_30' = 30,
    }
}

